import React from "react";
import { MODE_OF_TRANSPORT } from "../../../../models/Onboarding/onboarding-values";
import { useAppSelector as useSelector } from "../../../../store";
import { getEnumValue, parseJSON } from "../../../../utils/dataParser";

const JobPreferences: React.FC = () => {
  const userpersonaldetails = useSelector(
    (state) => state.onboarding.userpersonaldetails
  );
  const jobpreferences = useSelector(
    (state) => state.onboarding.jobpreferences
  );
  const mode_of_transport = parseJSON(
    jobpreferences?.preferred_transport_modes
  );

  return (
    <>
      <div className="d-flex flex-column gap-10">
        <div className="d-flex flex-column gap-5">
          <div className="fs-13 fw-400 text-grey-medium">
            You've noted your home address as:
          </div>
          <div className="fs-16 fw-400 text-black">
            {userpersonaldetails?.address}
          </div>
        </div>
        <div className="d-flex flex-column gap-5">
          <div className="fs-13 fw-400 text-grey-medium">
            Set your maximum travel distance from home:
          </div>
          <div className="fs-16 fw-400 text-black">
            {jobpreferences?.max_travel_distance} km
          </div>
        </div>
        <div className="d-flex flex-column gap-5">
          <div className="fs-13 fw-400 text-grey-medium">
            Your preferred job locations:
          </div>
          <div className="fs-16 fw-400 text-black">
            {jobpreferences?.jobpreferencesubrubs
              ?.map((item) => item.suburb.replace(/\s*-\s*\d+$/, ""))
              .join(", ") || "-"}
          </div>
        </div>
        <div className="d-flex flex-column gap-5">
          <div className="fs-13 fw-400 text-grey-medium">
            Select your preferred mode/s of transport:
          </div>
          <div className="fs-16 fw-400 text-black">
            {mode_of_transport
              .map((item: string) => getEnumValue(MODE_OF_TRANSPORT, item))
              .join(", ")}
          </div>
        </div>
      </div>
    </>
  );
};

export default JobPreferences;
